import React from "react";

export default function AccountPending() {
  return (
    <svg
      width="232"
      height="232"
      viewBox="0 0 232 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M201.739 116.004C201.739 68.6468 163.351 30.2622 115.999 30.2622C68.6455 30.2622 30.2578 68.6465 30.2578 116.004C30.2578 163.354 68.6455 201.741 115.999 201.741C163.351 201.741 201.739 163.354 201.739 116.004Z"
          fill="#32BEA6"
        />
        <path
          d="M97 85L97.0315 103.9L109.6 116.5L97.0315 129.132L97 148H134.8V129.1L122.2 116.5L134.8 103.932V85H97ZM128.5 130.675V141.7H103.3V130.675L115.9 118.075L128.5 130.675Z"
          fill="white"
        />
      </g>
      <circle
        cx="115.999"
        cy="116.002"
        r="89.2774"
        stroke="#32BEA6"
        strokeOpacity="0.8"
        strokeWidth="1.5"
        strokeDasharray="10 10"
      />
      <circle
        cx="115.998"
        cy="116"
        r="93.5644"
        transform="rotate(-5.77999 115.998 116)"
        stroke="#32BEA6"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeDasharray="11 11"
      />
      <circle
        cx="116"
        cy="116"
        r="97.8514"
        transform="rotate(11.2921 116 116)"
        stroke="#32BEA6"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeDasharray="12 12"
      />
      <circle
        cx="115.997"
        cy="116"
        r="102.138"
        transform="rotate(-5.89023 115.997 116)"
        stroke="#32BEA6"
        strokeOpacity="0.3"
        strokeWidth="1.5"
        strokeDasharray="13 13"
      />
      <circle
        cx="115.996"
        cy="116"
        r="106.425"
        stroke="#32BEA6"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeDasharray="15 15"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="171.481"
            height="171.481"
            fill="white"
            transform="translate(30.2578 30.2603)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
